module.exports = __webpack_public_path__ + "img/1 (94).634d132f.png";